/**
 * OKLab / OKLCH conversions, matrices per Björn Ottosson
 * (https://bottosson.github.io/posts/oklab/). Used for gradient
 * construction and interpolation per spec §9.4.
 */
import { linearToRgbUnit, rgbUnitToLinear } from "./srgb.js";
export function linearSrgbToOklab(c) {
    const l = 0.4122214708 * c.r + 0.5363325363 * c.g + 0.0514459929 * c.b;
    const m = 0.2119034982 * c.r + 0.6806995451 * c.g + 0.1073969566 * c.b;
    const s = 0.0883024619 * c.r + 0.2817188376 * c.g + 0.6299787005 * c.b;
    const l_ = Math.cbrt(l);
    const m_ = Math.cbrt(m);
    const s_ = Math.cbrt(s);
    return {
        L: 0.2104542553 * l_ + 0.793617785 * m_ - 0.0040720468 * s_,
        a: 1.9779984951 * l_ - 2.428592205 * m_ + 0.4505937099 * s_,
        b: 0.0259040371 * l_ + 0.7827717662 * m_ - 0.808675766 * s_,
    };
}
export function oklabToLinearSrgb(c) {
    const l_ = c.L + 0.3963377774 * c.a + 0.2158037573 * c.b;
    const m_ = c.L - 0.1055613458 * c.a - 0.0638541728 * c.b;
    const s_ = c.L - 0.0894841775 * c.a - 1.291485548 * c.b;
    const l = l_ * l_ * l_;
    const m = m_ * m_ * m_;
    const s = s_ * s_ * s_;
    return {
        r: +4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s,
        g: -1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s,
        b: -0.0041960863 * l - 0.7034186147 * m + 1.707614701 * s,
    };
}
export function srgbUnitToOklab(c) {
    return linearSrgbToOklab(rgbUnitToLinear(c));
}
export function oklabToSrgbUnit(c) {
    return linearToRgbUnit(oklabToLinearSrgb(c));
}
export function oklabToOklch(c) {
    const C = Math.sqrt(c.a * c.a + c.b * c.b);
    let H = (Math.atan2(c.b, c.a) * 180) / Math.PI;
    if (H < 0)
        H += 360;
    return { L: c.L, C, H };
}
export function oklchToOklab(c) {
    const hRad = (c.H * Math.PI) / 180;
    return { L: c.L, a: c.C * Math.cos(hRad), b: c.C * Math.sin(hRad) };
}
export function lerpOklab(a, b, t) {
    return {
        L: a.L + (b.L - a.L) * t,
        a: a.a + (b.a - a.a) * t,
        b: a.b + (b.b - a.b) * t,
    };
}
//# sourceMappingURL=oklab.js.map